import styled from 'styled-components';

/** Only rendered for a positive outstanding bank refund, including mixed payments. */
export default function RefundTransferDot() {
  return <Dot role="img" aria-label="환불 송금 대기" title="고객에게 송금할 환불이 있습니다." />;
}

const Dot = styled.span`
  display: inline-block; flex: 0 0 auto; width: var(--space-2); height: var(--space-2);
  margin-inline: var(--space-1); border-radius: var(--radius-pill); background: var(--color-text-danger);
  vertical-align: middle; position:relative; top:calc(var(--space-1) * -1);
`;
